import React from "react";
import WavesPlayField from "../components/WavesPlayField";

const WavesPage = () => {
  return <WavesPlayField />;
};

export default WavesPage;
